import { VariableType } from 'json-to-graphql-query';
import { Resource } from './resource';
/**
 * Media
 *
 * @export
 * @class MediaResource
 * @extends {Resource}
 */
export class MediaResource extends Resource {
    /**
     *  Pobiera informacje o mediach
     *
     * @param {number} id
     * @returns {Promise<MediaObjectType>}
     * @memberof MediaResource
     */
    async getMedia(id) {
        const query = this.prepareOptions({
            query: {
                __variables: { id: 'Int!' },
                media: {
                    __args: { id: new VariableType('id') },
                    id: true,
                    title: true,
                    size: true,
                    contentType: true,
                    isImage: true
                }
            }
        });
        return this.query({
            query,
            variables: { id }
        }, 'media');
    }
}
export const mediaResource = new MediaResource();
//# sourceMappingURL=media.resource.js.map